import React, { useState, useRef, useEffect, useMemo } from "react";
import UploadPopup from "../../../../../../common/components/upload-file-popup/upload-file-popup";
import { AlertComponent } from "../../../../../../common/components";
//import { addLeadDocument } from '../../../../../../api/lead'
import { useManualSetLoading } from "../../../../../../common/hooks/loadUntilCompOfApi";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Switch,
    Select,
    FormControl,
    Typography,
    IconButton,
    Grid,
    Box,
    TextField,
    Autocomplete,
} from "@mui/material";
import { Formik, Form, useFormikContext } from "formik";
import CloseIcon from "@mui/icons-material/Close";
import FileUploader from "./file-uploader";
import TextInputComponent from "../../../../../../common/components/text-input-component/text-input-component";
import SelectInputComponent from "../../../../../../common/components/select-input-component/select-input-component";
import { TASK_DIALOG_INITIAL_VALUES } from "../../../../../leads/lead-view/lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/common-dialog-task/common-dialog-helper";
import { categoryOptions, DOCUMENT_DIALOG_VALIDATION_SCHEMA, UPLOAD_DOCUMENT_INITIAL_VALUES } from "./customer-view-details-view-document-info.constant";
import { UploadFileDocumentsProps } from "./customer-view-details-view-document-info.props";
import { addCustomerDocument, editCustomerDocument } from "../../../../../../api/customer";
import DropzoneUploader from "./file-uploader";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

export type UploadFile = {
    id: string
    file: File
    name: string
    size: string
    progress: number
    status: 'pending' | 'uploading' | 'done' | 'error'
}


const UploadFileDocument: React.FC<UploadFileDocumentsProps> = ({
    open, onClose, onSave, leadId, title = "Create Document", initialDocument
}) => {
    const [alertMessage, setAlertMessage] = useState<string>("");
    const [alertType, setAlertType] = useState<"success" | "error">("success");
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // true if screen ≤ 600px
    const [alertOpen, setAlertOpen] = useState<boolean>(false);
    const [files, setFiles] = useState<UploadFile[]>([]);
    const [fileError, setFileError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false)
    const [formInitialValues, setFormInitialValues] = useState(UPLOAD_DOCUMENT_INITIAL_VALUES);
    const computedInitialValues = useMemo(() => {
        const existingFile = initialDocument?.file
            ? [{
                id: initialDocument.file.id,
                name: initialDocument.file.original_file_name,
                preview: initialDocument.link,
                file: null,
                isExisting: true,
                size: initialDocument.file.size, // ✅ Add this line
            }]
            : [];

        if (initialDocument) {
            return {
                documentName: initialDocument.document_name || "",
                documentCategory: initialDocument.document_category || "",
                files: existingFile,
            }
        } else {
            return UPLOAD_DOCUMENT_INITIAL_VALUES;
        }
    }, [initialDocument])
    const handleAttach = (values: any, newFiles: File[]) => {
        handleSave(values, newFiles);
    };

    const handleSave = async (values: any, files: File[]) => {
        setLoading(true)
        const formData = new FormData();
        console.log("values", values);
        formData.append("documentName", values.documentName);
        formData.append("documentCategory", values.documentCategory);
        files.forEach((file) => {
            formData.append(initialDocument?.id ? "file" : "files", file); // or "file", depending on API
        });
        try {
            let response;
            if (initialDocument?.id) {
                response = await editCustomerDocument(leadId, initialDocument.id, formData)
                setAlertMessage("Document updated successfully.");
            } else {
                response = await addCustomerDocument(leadId, formData)
                setAlertMessage("Document created successfully.");
            }
            if (response) {
                setAlertMessage(`${files?.length > 1 ? 'Files' : 'File'} uploaded successfully`);
                setAlertType("success");
                setFiles([])
                onSave(response?.data || values);
                onClose()
            }
        } catch (error: any) {
            setAlertMessage(error?.response?.data?.message || error?.response?.data?.error || "Something went wrong. Please try again later.");
            setAlertType("error");
        } finally {
            setLoading(false);
        }
    }
    const handleAlertClose = () => {
        setAlertOpen(false);
    };
    const showLoading = useMemo(() => loading, [loading]);
    useManualSetLoading(showLoading);

    return (
        <>
            {/* Main Task Dialog */}
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                fullWidth
                maxWidth="sm"
                slotProps={{
  paper: {
    sx: {
      width: isMobile ? "90%" : "570px", // 90% width on mobile
      maxWidth: "95vw",                  // prevent overflow
      minHeight: isMobile ? "auto" : "280px",
      borderBottomLeftRadius: '30px',
     borderBottomRightRadius: '30px',
      top: 0,  // add spacing from top on mobile
      margin: 0,
      position: "absolute",
    },
  },
}}
            >
                <DialogTitle
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: 1,
                        paddingLeft: 3,
                        borderBottom: "1px solid #E1E1E1",
                    }}
                >
                    <Typography variant="h6" sx={{ fontWeight: "bold !important" }}>
                        {title}
                    </Typography>
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <Formik
                    enableReinitialize
                    initialValues={computedInitialValues}
                    validationSchema={DOCUMENT_DIALOG_VALIDATION_SCHEMA}
                    onSubmit={(values) => {
                        const onlyNewFiles = values.files.filter((f: any) => f.file instanceof File);
                        handleAttach(values, onlyNewFiles.map((f: any) => f.file)); // Send new files only
                    }}

                >
                    {({ values, handleChange, setFieldValue, errors, touched, dirty }) => {

                        return (
                            <Form>
                                <DialogContent>
                                    <div className="task-dialog-container">
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Box display="flex" alignItems="center" gap={6}>
                                                    <Typography width={100}>Document Name</Typography>
                                                    <Box flex={1}>
                                                        <TextInputComponent
                                                            type="text"
                                                            fieldName="documentName"
                                                            placeholder="Enter Document Name"
                                                            optional={false}
                                                            disabled={false}
                                                            value={values.documentName}
                                                            onChange={handleChange}
                                                            maxlength="100"
                                                            isRequired={true}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Grid>

                                            <Grid item xs={12}>
                                                <Box display="flex" alignItems="center" gap={6}>
                                                    <Typography width={100}>Category</Typography>
                                                    <Box flex={1}>
                                                        <SelectInputComponent
                                                            fieldName="documentCategory"
                                                            value={values.documentCategory}
                                                            onChange={(e: any) => setFieldValue("documentCategory", e)}
                                                            options={categoryOptions}
                                                            optional={true}
                                                            isShowError={!values.documentCategory}
                                                            placeholder="Select Category"
                                                            isRequired={true}
                                                        />
                                                    </Box>
                                                </Box>
                                            </Grid>
                                            <DropzoneUploader
                                                value={values.files}
                                                onChange={(files) => setFieldValue("files", files)}
                                                error={touched.files && (errors.files as string)}
                                                isEditMode={title === "Edit Document"}
                                            />

                                        </Grid>
                                    </div>
                                </DialogContent>

                                <DialogActions sx={{ margin: "12px" }}>
                                    <button onClick={() => { onClose(); setFiles([]) }} className="cancel-button">
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="cancel-button next-button-wrapper"
                                        disabled={
                                            loading ||
                                            (Boolean(initialDocument?.id) && !dirty) // Disable if editing and no changes
                                        }
                                    >
                                        Upload
                                    </button>
                                </DialogActions>
                            </Form>
                        );
                    }}
                </Formik>
            </Dialog>
            {/* Alert Component */}
            <AlertComponent
                message={alertMessage}
                type={alertType}
                open={alertOpen}
                onClose={handleAlertClose}
            />
        </>

    )
}

export default UploadFileDocument;